var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToggleCarFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28906 29.3368C4.28906 32.7133 6.76149 35.4511 9.81172 35.4511C12.8612 35.4511 15.3336 32.7133 15.3336 29.3368H4.28906Z",
    fill: "#C5F4E0",
    stroke: "#63768D",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4375 29.3368C27.4375 32.7133 29.9099 35.4511 32.9594 35.4511C36.0096 35.4511 38.482 32.7133 38.482 29.3368H27.4375Z",
    fill: "#C5F4E0",
    stroke: "#63768D",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14286 16.7143H2.33551C1.04641 16.7143 0 15.9295 0 14.9635V14.6088C0 13.6411 1.04641 12.8572 2.33551 12.8572H5.14286V16.7143Z",
    fill: "#C5F4E0",
    stroke: "#63768D",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5703 16.7143H40.6754C41.6428 16.7143 42.4275 15.9295 42.4275 14.9635V14.6088C42.4275 13.6411 41.6428 12.8572 40.6754 12.8572H38.5703V16.7143Z",
    fill: "#C5F4E0",
    stroke: "#63768D",
    strokeWidth: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2878 15.1333C39.424 15.3238 39.5042 15.557 39.5042 15.809V28.1734C39.5042 28.8153 38.9827 29.3368 38.3409 29.3368H4.48753C3.84493 29.3368 3.32422 28.8153 3.32422 28.1734V15.809C3.32422 15.4705 3.46868 15.1659 3.69933 14.9533L7.92864 5.72619C9.35964 2.70064 12.4068 0.771301 15.7532 0.771301H26.8047C30.0825 0.771301 33.0788 2.62196 34.5452 5.55339L39.2878 15.1333Z",
    fill: "#81E5BD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2878 15.1333L38.8397 15.3551L38.8577 15.3913L38.8811 15.4241L39.2878 15.1333ZM3.69933 14.9533L4.03817 15.321L4.11201 15.2529L4.15386 15.1616L3.69933 14.9533ZM7.92864 5.72619L7.47662 5.51239L7.47411 5.51785L7.92864 5.72619ZM34.5452 5.55339L34.9933 5.33155L34.9924 5.32969L34.5452 5.55339ZM38.8811 15.4241C38.9587 15.5326 39.0042 15.6648 39.0042 15.809H40.0042C40.0042 15.4492 39.8894 15.1149 39.6946 14.8425L38.8811 15.4241ZM39.0042 15.809V28.1734H40.0042V15.809H39.0042ZM39.0042 28.1734C39.0042 28.5391 38.7066 28.8368 38.3409 28.8368V29.8368C39.2589 29.8368 40.0042 29.0914 40.0042 28.1734H39.0042ZM38.3409 28.8368H4.48753V29.8368H38.3409V28.8368ZM4.48753 28.8368C4.12129 28.8368 3.82422 28.5393 3.82422 28.1734H2.82422C2.82422 29.0912 3.56857 29.8368 4.48753 29.8368V28.8368ZM3.82422 28.1734V15.809H2.82422V28.1734H3.82422ZM3.82422 15.809C3.82422 15.6159 3.90597 15.4428 4.03817 15.321L3.36048 14.5856C3.03139 14.8889 2.82422 15.3251 2.82422 15.809H3.82422ZM4.15386 15.1616L8.38317 5.93452L7.47411 5.51785L3.2448 14.745L4.15386 15.1616ZM8.38064 5.93997C9.72897 3.0892 12.6001 1.2713 15.7532 1.2713V0.271301C12.2135 0.271301 8.99031 2.31209 7.47665 5.51241L8.38064 5.93997ZM15.7532 1.2713H26.8047V0.271301H15.7532V1.2713ZM26.8047 1.2713C29.8933 1.2713 32.7163 3.01506 34.0981 5.77709L34.9924 5.32969C33.4412 2.22885 30.2718 0.271301 26.8047 0.271301V1.2713ZM34.0971 5.77522L38.8397 15.3551L39.7359 14.9115L34.9933 5.33155L34.0971 5.77522Z",
    fill: "#63768D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.76242 15.0551C7.40595 15.0551 7.16483 14.7527 7.29964 14.4776L10.6489 7.64123C11.7913 5.6197 14.2234 3.48364 16.8952 3.48364H25.7159C28.3328 3.48364 30.7239 5.56794 31.8948 7.52608L35.5053 14.4689C35.6492 14.7457 35.4067 15.0551 35.0467 15.0551H7.76242Z",
    fill: "#C5F4E0",
    stroke: "#63768D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9099 25.7161H18.4006C17.8182 25.7161 17.3438 25.2433 17.3438 24.6593V24.0869C17.3438 23.5029 17.8182 23.03 18.4006 23.03H24.9099C25.4939 23.03 25.9668 23.5029 25.9668 24.0869V24.6593C25.9668 25.2433 25.4939 25.7161 24.9099 25.7161Z",
    fill: "#63768D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6052 19.8205L32.0543 22.5583C31.5474 22.9301 30.8146 22.8476 30.4158 22.3732L29.7593 21.5894C29.1576 20.8712 29.7037 19.8205 30.6773 19.8205H35.6052Z",
    stroke: "#63768D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22266 19.8205L10.7735 22.5583C11.2811 22.9301 12.014 22.8476 12.4121 22.3732L13.0693 21.5894C13.671 20.8712 13.1249 19.8205 12.1513 19.8205H7.22266Z",
    stroke: "#63768D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6007 19.8205H7.78125",
    stroke: "#63768D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleCarFront);
export default __webpack_public_path__ + "static/media/toggle-car-front.c93c92b7.svg";
export { ForwardRef as ReactComponent };